import React from 'react';
import {BrowserRouter, Route, Routes} from 'react-router-dom';

import {useMediaQuery} from './hooks/useMediaQuery';

import Header from './components/header/Header';
import MobileHeader from './components/header/MobileHeader';
import Footer from './components/footer/Footer';
import AboutPage from './pages/AboutPage';
import AdminPage from './pages/AdminPage';
import ChatPage from './pages/ChatPage';
import MainPage from './pages/MainPage';

import './styles/variables.css';

export default function App() {
  const mobile = useMediaQuery('(max-width: 768px)');

  return (
    <BrowserRouter>
       {mobile ? <MobileHeader /> : <Header />}
        <Routes>
          <Route path='/' element={<MainPage />} />
          <Route path='/about' element={<AboutPage />} />
          <Route path='/service'>
            <Route path='admin' element={<AdminPage />} />
            <Route path='chat' element={<ChatPage />} />
          </Route>
        </Routes>
       <Footer />
    </BrowserRouter>
  );
}
